import {
  AfterViewInit,
  Component,
  forwardRef,
  inject,
  input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { debounceTime, finalize, map, Observable, of, Subject } from 'rxjs';
import {BusinessType, ManufacturerDto, Province} from '../../../../generated-model/model';
import {
  NgLabelTemplateDirective,
  NgOptionTemplateDirective,
  NgSelectComponent,
} from '@ng-select/ng-select';
import { AsyncPipe, NgIf } from '@angular/common';
import { ManufacturerRest } from '../../../service/ManufacturerRest';

@Component({
  selector: 'app-manufacturer-autocomplete',
  standalone: true,
  imports: [
    FormsModule,
    NgSelectComponent,
    AsyncPipe,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgIf,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ManufacturerAutocompleteComponent),
      multi: true,
    },
  ],
  templateUrl: './manufacturer-autocomplete.component.html',
})
export class ManufacturerAutocompleteComponent
  implements ControlValueAccessor, OnInit, AfterViewInit, OnChanges
{
  manufacturers$: Observable<ManufacturerDto[]> = of([]);
  term$ = new Subject<string>();
  typeaheadLoading = false;
  value: ManufacturerDto = null;
  id = input<string>('manufacturer');
  name = input<string>('manufacturer');
  businessType = input<BusinessType>();
  province = input<Province>();
  disabled = input<boolean>();
  touched = false;
  private manufacturerService = inject(ManufacturerRest);
  @ViewChild('ngSelectComponent', { static: true, read: NgSelectComponent })
  ngSelectComponent: NgSelectComponent;

  onChange = (value: any) => {};
  onTouched = () => {};

  compareWithCode = (o1: any, o2: any): boolean => {
    return o1 == o2 || (!!o1 && !!o2 && o1.id == o2.id);
  };

  constructor() {}

  ngAfterViewInit() {}

  ngOnInit(): void {
    this.term$.pipe(debounceTime(500)).subscribe((term) => {
      this.typeaheadLoading = true;
      this.manufacturers$ = this.manufacturerService
        .searchAutoComplete(term, this.province(), this.businessType())
        .pipe(
          map((e) => {
            return e;
          }),
          finalize(() => (this.typeaheadLoading = false))
        );
    });
  }

  writeValue(value: ManufacturerDto) {
    this.value = value;
  }

  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  onValueChange(value: ManufacturerDto) {
    this.onChange(value);
    this.markAsTouched();
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const businessType = changes['businessType']
    const province = changes['province']
    if(businessType || province){
      this.value=null;
      this.onValueChange(null);
      this.term$.next('');
      this.ngSelectComponent.searchTerm=null;
    }
  }
  onOpen(){
    this.term$.next('');
  }
}
